exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mh-36[data-v-a4a5ea0a]{max-height:36px}", ""]);

// exports
